// extracted by mini-css-extract-plugin
export var actionText = "_ry-4";
export var container = "_ry-0";
export var leftSection = "_ry-1";
export var rightSection = "_ry-2";
export var settingsButton = "_ry-6";
export var settingsIcon = "_ry-7";
export var shortcut = "_ry-5";
export var shortcutGroup = "_ry-3";